class GrArtboardSlider extends HTMLElement {
  connectedCallback() {
    if (this.controller) return;
    this.controller = new AbortController();
    const options = { signal: this.controller.signal };
    this.slides = [...this.querySelectorAll('.gr-artboard-slide')];
    this.dots = [...this.querySelectorAll('[data-slide-to]')];
    this.status = this.querySelector('.gr-slide-status');
    this.motion = matchMedia('(prefers-reduced-motion: reduce)');
    this.index = 0;
    this.paused = this.motion.matches;
    this.hovering = false;
    this.focused = false;
    this.visible = true;
    this.querySelector('.gr-slide-controls').hidden = false;
    this.dots.forEach(button => button.addEventListener('click', () => this.go(Number(button.dataset.slideTo), true), options));
    this.addEventListener('mouseenter', () => { this.hovering = true; this.schedule(); }, options);
    this.addEventListener('mouseleave', () => { this.hovering = false; this.schedule(); }, options);
    this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, options);
    this.addEventListener('focusout', event => { this.focused = this.contains(event.relatedTarget); this.schedule(); }, options);
    this.addEventListener('keydown', event => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      this.go(this.index + (event.key === 'ArrowRight' ? 1 : -1), true);
    }, options);
    const stage = this.querySelector('.gr-slide-stage');
    stage.addEventListener('pointerdown', event => { this.touch = { x: event.clientX, y: event.clientY }; }, options);
    stage.addEventListener('pointerup', event => {
      if (!this.touch) return;
      const dx = event.clientX - this.touch.x;
      const dy = event.clientY - this.touch.y;
      this.touch = null;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) this.go(this.index + (dx < 0 ? 1 : -1), true);
    }, options);
    stage.addEventListener('pointercancel', () => { this.touch = null; }, options);
    document.addEventListener('visibilitychange', () => this.schedule(), options);
    this.motion.addEventListener('change', () => { this.paused = this.motion.matches; this.schedule(); }, options);
    this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.schedule(); });
    this.observer.observe(this);
    this.go(0);
  }
  go(index, manual = false) {
    this.index = (index + this.slides.length) % this.slides.length;
    this.slides.forEach((slide, i) => {
      const active = i === this.index;
      slide.classList.toggle('is-active', active);
      slide.setAttribute('aria-hidden', String(!active));
      slide.inert = !active;
    });
    this.dots.forEach((dot, i) => {
      if (i === this.index) dot.setAttribute('aria-current', 'true');
      else dot.removeAttribute('aria-current');
    });
    if (manual) {
      this.status.textContent = this.slides[this.index].getAttribute('aria-label');
    }
    this.schedule();
  }
  schedule() {
    clearTimeout(this.timer);
    if (this.paused || this.hovering || this.focused || document.hidden || !this.visible) return;
    this.timer = setTimeout(() => this.go(this.index + 1), Number(this.dataset.interval) || 1500);
  }
  disconnectedCallback() {
    clearTimeout(this.timer);
    this.observer?.disconnect();
    this.controller?.abort();
    this.controller = null;
  }
}
if (!customElements.get('gr-artboard-slider')) customElements.define('gr-artboard-slider', GrArtboardSlider);
